/* eslint-disable */
import { produce } from "immer";
import {
  SUBMIT_DOC_PATCH_START,
  SUBMIT_DOC_PATCH_SUCCESS,
  SUBMIT_DOC_PATCH_FAILURE,
} from "../actions/types";

const submitDoc = (
  state = {
    submitDocFetching: false,
    submitDocData: {},
    submitDocError: null,
  },
  action,
) => {
  switch (action.type) {
    case SUBMIT_DOC_PATCH_START:
      return produce(state, (draft) => {
        draft.submitDocFetching = true;
      });
    case SUBMIT_DOC_PATCH_SUCCESS:
      return produce(state, (draft) => {
        draft.submitDocFetching = true;
        draft.submitDocData = action.data;
        draft.submitDocFetching = false;
      });
    case SUBMIT_DOC_PATCH_FAILURE:
      return produce(state, (draft) => {
        draft.submitDocFetching = false;
        draft.submitDocError = action.error;
      });
    default:
      return state;
  }
};

export default submitDoc;
